"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage"));
var _makeMethod = require("@/api/goods/makeMethod");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'makeMethodTypeManage',
  components: {
    SwPage: _SwPage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      dataList: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        keywords: null
      }
    };
  },
  created: function created() {
    this.getList();
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 272, "px");
    }
  },
  methods: {
    // 处理选择模式开关
    handleSelectModel: function handleSelectModel(row) {
      var _this = this;
      (0, _makeMethod.updateType)({
        id: row.id,
        selectModel: row.selectModel
      }).then(function (res) {
        if (res.code === 0) {
          _this.$message.success('操作成功');
          _this.getList();
        } else {
          _this.getList(); // 失败时刷新恢复原值
        }
      }).catch(function () {
        _this.getList(); // 失败时刷新恢复原值
      });
    },
    // 处理是否必选开关
    handleSelfSelect: function handleSelfSelect(row) {
      var _this2 = this;
      (0, _makeMethod.updateType)({
        id: row.id,
        selfSelect: row.selfSelect
      }).then(function (res) {
        if (res.code === 0) {
          _this2.$message.success('操作成功');
          _this2.getList();
        } else {
          _this2.getList(); // 失败时刷新恢复原值
        }
      }).catch(function () {
        _this2.getList(); // 失败时刷新恢复原值
      });
    },
    getList: function getList() {
      var _this3 = this;
      this.listLoading = true;
      (0, _makeMethod.queryTypePageList)(this.listQuery).then(function (response) {
        if (response) {
          _this3.dataList = response.records;
          _this3.total = response.total;
        }
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      }, function () {
        setTimeout(function () {
          _this3.listLoading = false;
        }, 0.5 * 1000);
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    retPage: function retPage() {
      this.getList();
    }
  }
};